import { ChangeDetectionStrategy, Component, Inject, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { FilterConfig, FiltersConfig, FilterTypes } from '@next/core-lib/components';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { FormatLocationPipe } from '@next/core-lib/pipes';
import { Store } from '@ngrx/store';
import { Observable, of, Subject } from 'rxjs';
import { CatalogItem } from 'src/app/models/catalog-item.model';
import { Environment } from 'src/environments/environment.model';

import { setSelectedCatalogCategory } from '../../store/actions';
import { selectCatalogCategories } from '../../store/selectors';
import { CatalogCategorySelectorComponent } from '../catalog-category-selector/catalog-category-selector.component';
import { CatalogProductComponent } from '../catalog-products/catalog-products.component';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  providers: [FormatLocationPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CatalogCategorySelectorComponent, CatalogProductComponent],
})
export class CatalogComponent implements OnDestroy {
  @ViewChild('productColumn') productColumn: TemplateRef<unknown>;
  @ViewChild('addToCartColumn') addToCartColumn: TemplateRef<unknown>;

  catalogCategories$: Observable<CatalogItem[]> = this.store.select(selectCatalogCategories);

  searchChanges$ = new Subject<string>();

  subTitle: string;
  searchInput: string;

  filterConfig: FilterConfig<FiltersConfig> = {
    filters: {
      search: {
        type: FilterTypes.Text,
        label: this.locale.translate('app.catalog.filter.search'),
        defaultValue: of(''),
        placeholder: this.locale.translate('app.catalog.filter.search'),
        priority: true,
        changes: this.searchChanges$,
      },
    },
  };

  constructor(
    private readonly store: Store<RootState>,
    private readonly locale: LocaleService,
    @Inject(EnvironmentInjector) readonly environment: Environment,
  ) {}

  ngOnDestroy(): void {
    this.store.dispatch(
      setSelectedCatalogCategory({
        selectedCatalogCategory: null,
      }),
    );
  }
}
